import { useRef, useCallback } from "react";

const COLORS = ["#ff5a2c", "#0ebb74", "#9932ec", "#3283ba", "#fbeee8", "#fb2576"];
const PARTICLE_COUNT = 150;
const MAX_FRAMES = 100;

export function useConfetti() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const fire = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const particles = Array.from({ length: PARTICLE_COUNT }, () => ({
      x: canvas.width / 2 + (Math.random() - 0.5) * 300,
      y: canvas.height / 2,
      vx: (Math.random() - 0.5) * 20,
      vy: Math.random() * -22 - 5,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: Math.random() * 10 + 4,
      rotation: Math.random() * 360,
      rotSpeed: (Math.random() - 0.5) * 15,
      gravity: 0.4 + Math.random() * 0.2,
      opacity: 1,
    }));
    let frame = 0;
    const animate = () => {
      if (frame >= MAX_FRAMES) { ctx.clearRect(0, 0, canvas.width, canvas.height); return; }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.x += p.vx; p.vy += p.gravity; p.y += p.vy;
        p.rotation += p.rotSpeed; p.vx *= 0.98;
        p.opacity = Math.max(0, 1 - frame / MAX_FRAMES);
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      });
      frame++;
      requestAnimationFrame(animate);
    };
    animate();
  }, []);

  return { canvasRef, fire };
}
